const industry_CN_Locale = {
    'industry.title': '行业头部机构、企业的共同选择'
}
export default industry_CN_Locale
